import { TypedDocumentNode, gql } from '@apollo/client';

import { isType, withFragments } from '@sorare/core/src/gql';

import { useHasRivalsLeagues_so5Root } from './__generated__/useHasRivalsLeagues.graphql';

export const useHasRivalsLeagues = withFragments(
  (so5Root: Nullable<useHasRivalsLeagues_so5Root>) => {
    const hasFriendsLeagues = !!so5Root?.myUserGroups?.nodes.some(
      node => isType(node, 'RivalsUserGroup') && !node.affiliate
    );
    const hasAffiliateLeagues = !!so5Root?.myUserGroups?.nodes.some(
      node => isType(node, 'RivalsUserGroup') && node.affiliate
    );

    const hasLeagues = hasFriendsLeagues || hasAffiliateLeagues;
    return { hasFriendsLeagues, hasAffiliateLeagues, hasLeagues };
  },
  {
    so5Root: gql`
      fragment useHasRivalsLeagues_so5Root on So5Root {
        myUserGroups {
          nodes {
            slug
            ... on RivalsUserGroup {
              slug
              affiliate
            }
          }
        }
      }
    ` as TypedDocumentNode<useHasRivalsLeagues_so5Root>,
  }
);
